import { makeAutoObservable, runInAction } from "mobx";
import { surveysService } from "../services";
import { resolveSurveyType } from "../utils/survey-take";

class SurveyTakeStore {
  open = false;
  loading = false;
  error = "";
  survey = null;
  responses = {};
  submitting = false;
  currentStep = 0;
  score = null;
  startTime = Date.now();
  viewMode = "questions";
  submissionMeta = null;

  constructor() {
    makeAutoObservable(this);
  }

  resetSession = () => {
    this.responses = {};
    this.submitting = false;
    this.currentStep = 0;
    this.score = null;
    this.startTime = Date.now();
    this.viewMode = "questions";
    this.submissionMeta = null;
  };

  setSurvey = (survey) => {
    const nextId = survey?._id || null;
    const currentId = this.survey?._id || null;
    this.survey = survey || null;
    if (nextId !== currentId) {
      this.resetSession();
    }
  };

  openTake = (survey) => {
    this.open = true;
    this.error = "";
    this.setSurvey(survey || null);
    if (survey && !Array.isArray(survey.questions)) {
      this.loadSurveyDetails(survey);
    }
  };

  close = () => {
    this.open = false;
    this.error = "";
    this.survey = null;
    this.resetSession();
  };

  setResponse = (questionId, value) => {
    this.responses = { ...this.responses, [questionId]: value };
  };

  setSubmitting = (value) => {
    this.submitting = value;
  };

  setCurrentStep = (value) => {
    this.currentStep = value;
  };

  setScore = (value) => {
    this.score = value;
  };

  setViewMode = (value) => {
    this.viewMode = value;
  };

  setSubmissionMeta = (value) => {
    this.submissionMeta = value;
  };

  loadSurveyDetails = async (survey) => {
    if (!survey?._id) return;
    runInAction(() => {
      this.loading = true;
      this.error = "";
    });

    try {
      const isStandard = resolveSurveyType(survey) === "StandardSurvey";
      const fetcher = isStandard
        ? surveysService.getStandardSurvey
        : surveysService.getCustomSurvey;
      const data = await fetcher(survey._id);

      const payload = data?.survey || data?.data?.survey || data?.survey;
      runInAction(() => {
        this.setSurvey(payload || survey);
      });
    } catch (error) {
      runInAction(() => {
        this.error = error?.message || "Unable to load survey.";
      });
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  };
}

export const surveyTakeStore = new SurveyTakeStore();
